<template>
  <div>
    <div v-if="loading" style="text-align: center; padding-top: 15vw">
      <md-progress-spinner
        :md-diameter="200"
        :md-stroke="10"
        md-mode="indeterminate"
      />
    </div>

    <div v-if="!loading" style="min-height: 100vh">
      <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
          <h1>Comandos automáticos</h1>
        </div>
        <div class="md-layout-item md-small-size-50 md-size-10">
          <md-button
            class="md-button md-primary"
            @click="() => (openFormImportarComando = true)"
          >
            Importar
          </md-button>
        </div>
        <div class="md-layout-item md-small-size-50 md-size-10">
          <md-button class="md-button md-primary" @click="handleGerarComando">
            Gerar comando
          </md-button>
        </div>
        <div class="md-layout-item md-small-size-50 md-size-10">
          <md-button
            class="md-button md-primary"
            @click="handleAdicionarComando"
          >
            Adicionar
          </md-button>
        </div>
        <div
          v-if="isAdmin()"
          class="md-layout-item md-small-size-50 md-size-10"
        >
          <md-button
            class="md-button md-primary"
            @click="() => (openFormComandoTitulo = true)"
          >
            Comandos
          </md-button>
        </div>
        <div class="md-layout-item md-small-size-50 md-size-10">
          <md-button
            class="md-button md-primary md-raised"
            @click="handleSalvarAlteracoes"
          >
            Salvar Alterações
          </md-button>
        </div>
      </div>
      <md-card
        v-for="(comando, idx) in comandos"
        :key="comando.titulo"
        class="mb-3"
      >
        <md-card-header>
          <div class="md-layout">
            <div class="md-layout-item md-size-30">
              <div class="md-title">
                {{ comando.titulo }}
              </div>
              <div class="md-subhead">
                {{ comandosTitulo[comando.comando] || comando.comando }}
                <span
                  v-if="!comando.comando"
                  class="md-error"
                  style="color: red"
                >
                  Deve-se configurar comando para esse equipamento
                </span>
              </div>
            </div>

            <div class="md-layout-item">
              <div class="md-layout" style="align-items: center">
                <div class="md-layout-item md-small-size-40 md-size-15">
                  <md-field style="width: auto">
                    <label for="horarioInicio">Início</label>
                    <md-input
                      id="horarioInicio"
                      v-model="comando.horario.inicio"
                      v-mask="'##:##'"
                      name="horarioInicio"
                    />
                  </md-field>
                </div>
                <div
                  class="md-layout-item md-size-20"
                  style="text-align: center"
                >
                  <md-icon class="md-size-2x"> arrow_right_alt </md-icon>
                </div>
                <div class="md-layout-item md-small-size-40 md-size-15">
                  <md-field style="width: auto">
                    <label for="fim">Fim</label>
                    <md-input
                      v-model="comando.horario.fim"
                      v-mask="'##:##'"
                      name="horariofim"
                    />
                  </md-field>
                </div>
              </div>
            </div>

            <div class="md-layout-item pr-2" style="text-align: right">
              <div
                class="row"
                style="align-items: center; justify-content: flex-end"
              >
                <div>
                  <md-switch v-model="comando.ativado" />
                </div>
                <md-button
                  class="md-accent"
                  @click="() => handleRemoverComando(comando)"
                >
                  Remover
                </md-button>
              </div>
            </div>
          </div>
        </md-card-header>

        <md-card-expand>
          <md-card-actions md-alignment="space-between">
            <div />

            <md-card-expand-trigger>
              <md-button :ref="`expand${idx}`" class="md-icon-button">
                <md-icon>keyboard_arrow_down</md-icon>
              </md-button>
            </md-card-expand-trigger>
          </md-card-actions>

          <md-card-expand-content>
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item">
                  <div style="text-align: left">
                    <md-button
                      @click="
                        openFormCriacao = true
                        comandoForm = comando
                      "
                    >
                      Adicionar expressão
                    </md-button>
                  </div>
                  <div
                    v-for="expressao in comando.expressoes"
                    :key="getExpressaoKey(expressao)"
                  >
                    <MotoBombaExpressaoForm
                      :ref="`motoBombaEdit${getExpressaoKey(expressao)}`"
                      :sensores="equipamento.sensores"
                      :expressao="expressao"
                      @update="
                        (e) =>
                          handleChangeMotoBombaExpressao(comando, expressao, e)
                      "
                      @remove="() => handleRemoveExpressao(comando, expressao)"
                    />
                  </div>
                </div>

                <div
                  class="md-layout-item md-size-30 vertical-divider"
                  style="text-align: right"
                >
                  <MotoBombaComandoForm
                    :comandos-titulo="comandosTitulo"
                    :comando="comando"
                    @change="
                      (e) => handleChangeMotoBombaComandoForm(comando, e)
                    "
                  />
                </div>
              </div>
            </md-card-content>
          </md-card-expand-content>
        </md-card-expand>
      </md-card>
    </div>

    <div>
      <md-dialog :md-active.sync="openFormCriacao">
        <md-dialog-title>Adicionar condição</md-dialog-title>

        <MotoBombaExpressaoForm
          ref="motoBombaForm"
          :sensores="equipamento.sensores"
          class="m-4"
          new-form
        />

        <md-dialog-actions>
          <md-button class="md-primary" @click="openFormCriacao = false">
            Cancelar
          </md-button>
          <md-button class="md-primary" @click="handleAdicionarExpressao">
            Adicionar
          </md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog :md-active.sync="openFormComandoTitulo">
        <md-dialog-title>Configurar Comandos</md-dialog-title>

        <MotoBombaComandoTituloForm
          :initial-comandos-titulo="comandosTitulo"
          @change="(e) => (comandosTitulo = e)"
        />

        <md-dialog-actions>
          <md-button class="md-primary" @click="openFormComandoTitulo = false">
            Fechar
          </md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog :md-active.sync="openDialogGerarComando">
        <md-dialog-title>Comando</md-dialog-title>

        <div style="min-width: 50vw">
          <div v-if="!comandoGerado" class="p-5" style="text-align: center">
            <md-progress-spinner
              :md-diameter="100"
              :md-stroke="8"
              md-mode="indeterminate"
            />
          </div>

          <div v-if="comandoGerado" class="p-4">
            {{ comandoGerado }}
          </div>
        </div>

        <md-dialog-actions>
          <md-button
            class="md-primary"
            @click="
              openDialogGerarComando = false
              comandoGerado = null
            "
          >
            Fechar
          </md-button>
        </md-dialog-actions>
      </md-dialog>

      <MotoBombaImportarComando
        :open-dialog.sync="openFormImportarComando"
        @comando="handleComandoImportado"
        @close="() => (openFormImportarComando = false)"
      />
    </div>
  </div>
</template>

<script>
import MotoBombaComandoForm from '@/components/equipamento/MotoBombaComandoForm.vue'
import MotoBombaComandoTituloForm from '@/components/equipamento/MotoBombaComandoTituloForm.vue'
import MotoBombaExpressaoForm from '@/components/equipamento/MotoBombaExpressaoForm.vue'
import MotoBombaImportarComando from '@/components/equipamento/MotoBombaImportarComando.vue'
import DurationInput from '@/components/input/DurationInput.vue'
import { EventBus, Topics, Types } from '@/event-bus'
import auth from '@/utils/auth'
import http from '@/utils/http'
import { validaData } from '@/utils/validations/date'

export default {
  name: 'EquipamentoMotoBombaConfig',
  components: {
    DurationInput,
    MotoBombaImportarComando,
    MotoBombaComandoTituloForm,
    MotoBombaComandoForm,
    MotoBombaExpressaoForm,
  },
  props: {
    equipamento: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    openFormCriacao: false,
    openFormComandoTitulo: false,
    openFormImportarComando: false,
    openDialogGerarComando: false,
    comandoGerado: null,
    comandoForm: null,
    comandosTitulo: {},
    comandos: [],
  }),
  mounted() {
    const value = this.equipamento.config.find(
      (e) => e.configName === 'MotoBombaConfig'
    )?.config?.value

    if (value) {
      this.comandos = value.comandos.map((e) => ({
        ...e,
        horario: e.horario ?? {
          inicio: '',
          fim: '',
        },
      }))
      this.comandosTitulo = value.comandosTitulo
    }

    this.$nextTick(() => {
      if (this.comandos.length === 1) {
        this.$refs[`expand${this.comandos.length - 1}`][0].$el.click()
      }
    })
  },
  methods: {
    handleComandoImportado(data) {
      this.comandos = data
      this.openFormImportarComando = false
    },
    handleGerarComando() {
      const comandos = this.validarComandos()

      if (comandos === null) {
        return
      }

      this.openDialogGerarComando = true

      http
        .post(
          `equipamento/calibracao/${this.equipamento.id}/configuracao/gerar-comando/moto-bomba`,
          {
            bombaConfig: {
              comandosTitulo: this.comandosTitulo,
              comandos: comandos,
            },
          },
          false
        )
        .then((e) => (this.comandoGerado = e.comando))
    },
    handleChangeMotoBombaExpressao(comando, expressao, novo) {
      this.comandos = this.comandos.map((c) => {
        if (c === comando) {
          c.expressoes = c.expressoes.map((e) => {
            if (e === expressao) {
              return novo
            }

            return e
          })
        }

        return c
      })
    },
    handleChangeMotoBombaComandoForm(old, newComando) {
      this.comandos = this.comandos.map((c) => {
        if (c === old) {
          return {
            ...c,
            ...newComando,
          }
        }

        return c
      })
    },
    isAdmin() {
      return auth.isAdmin()
    },
    validarComandos() {
      if (this.comandos.length === 0) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.DANGER,
          message: 'É necessário adicionar ao menos um comando.',
        })
        return null
      }

      if (this.comandos.some((e) => e.expressoes.length === 0)) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.DANGER,
          message:
            'É necessário adicionar ao menos uma expressão para cada comando.',
        })
        return null
      }

      if (this.comandos.some((e) => e.comando === null || e.comando === '')) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.DANGER,
          message: 'É necessário configurar o comando a ser executado.',
        })
        return null
      }

      if (this.comandos.some((e) => e.titulo === null || e.titulo === '')) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.DANGER,
          message: 'É necessário configurar o titulo.',
        })
        return null
      }

      let valid = true
      let message = null
      const comandos = this.comandos.map((comando) => {
        const exp = comando.expressoes.map((expressao) => {
          const result =
            this.$refs[
              `motoBombaEdit${this.getExpressaoKey(expressao)}`
            ][0].submitForm()

          if (result === null) {
            valid = false
          }

          return result
        })

        if (comando.horario.inicio !== '' || comando.horario.fim !== '') {
          if (
            !validaData(comando.horario.inicio) ||
            !validaData(comando.horario.fim)
          ) {
            valid = false
            message = `Horário inválido para ${comando.titulo}.`
          }
        }
        const horario =
          comando.horario.inicio === '' && comando.horario.fim === ''
            ? null
            : comando.horario

        return {
          ...comando,
          horario: horario,
          expressoes: exp,
        }
      })

      if (!valid) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.DANGER,
          message: message ?? 'Existem campos inválidos.',
        })
        return null
      }

      return comandos
    },
    async handleSalvarAlteracoes() {
      const comandos = this.validarComandos()

      if (comandos === null) {
        return
      }

      await http.post(
        `equipamento/calibracao/${this.equipamento.id}/configuracao/moto-bomba`,
        {
          bombaConfig: {
            comandosTitulo: this.comandosTitulo,
            comandos: comandos,
          },
        }
      )

      this.$emit('update')
    },
    getExpressaoKey(expressao) {
      return expressao.sensor + expressao.comparador + expressao.valor
    },
    handleRemoveExpressao(comando, expressao) {
      this.comandos = this.comandos.map((c) => {
        if (c === comando) {
          c.expressoes = c.expressoes.filter((e) => e !== expressao)
        }

        return c
      })
    },
    handleAdicionarComando() {
      this.comandos.push({
        titulo: 'Comando ' + (this.comandos.length + 1),
        comando: null,
        horario: {
          inicio: '',
          fim: '',
        },
        ativado: true,
        expressoes: [
          {
            sensor: null,
            comparador: '<',
            valor: 0,
          },
        ],
      })
    },
    handleRemoverComando(comando) {
      this.comandos = this.comandos.filter((c) => c !== comando)
    },
    handleAdicionarExpressao() {
      const form = this.$refs.motoBombaForm.submitForm()

      if (form === null) {
        return null
      }

      this.comandos = this.comandos.map((c) => {
        if (c === this.comandoForm) {
          c.expressoes = [...c.expressoes, form]
        }

        return c
      })

      this.comandoForm = null
      this.openFormCriacao = false
    },
  },
}
</script>

<style scoped lang="scss">
.vertical-divider {
  border-left: 1px solid #e0e0e0;
}
</style>
